/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleBanner_browseContentModule = {
    readonly photo: string | null;
    readonly title: string | null;
    readonly subtitle: string | null;
    readonly description: string | null;
    readonly link: string | null;
    readonly linkText: string | null;
    readonly " $refType": "SbSharedContentModuleBanner_browseContentModule";
};
export type SbSharedContentModuleBanner_browseContentModule$data = SbSharedContentModuleBanner_browseContentModule;
export type SbSharedContentModuleBanner_browseContentModule$key = {
    readonly " $data"?: SbSharedContentModuleBanner_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedContentModuleBanner_browseContentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleBanner_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "photo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkText",
      "storageKey": null
    }
  ],
  "type": "ContentModuleBanner",
  "abstractKey": null
};
(node as any).hash = '721f11291a4c2bda1bf806b3ed653b1b';
export default node;
